import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "col-xs-12" }
const _hoisted_2 = { class: "row q-col-gutter-sm" }
const _hoisted_3 = { class: "column q-pa-sm q-col-gutter-sm w-72" }
const _hoisted_4 = { align: "right" }
const _hoisted_5 = { class: "row items-center no-wrap text-grey-10 text-weight-regular" }
const _hoisted_6 = { class: "text-weight-regular text-grey-7" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { align: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filters_stackable_inputs = _resolveComponent("filters-stackable-inputs")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_q_btn_dropdown, {
          "no-caps": "",
          color: "grey-3",
          "text-color": "grey-7",
          label: _ctx.filterLabel('addFilter'),
          ref: "newFilterRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_filters_stackable_inputs, {
                "fields-as-array": _ctx.fieldsAsArray,
                fields: _ctx.fields,
                onConditionalChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setNewCondition($event))),
                onEnterKey: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.conditionReady(_ctx.newCondition)
                  ? [
                      _ctx.addCondition(_ctx.newCondition),
                      _ctx.resetNewCondition(),
                      _ctx.conditionStackChange(),
                      _ctx.closeDialog(_ctx.newFilterRef),
                    ]
                  : ''
              ))
              }, null, 8, ["fields-as-array", "fields"]),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  class: "text-grey-7",
                  label: _ctx.t(`form.cancel`),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resetNewCondition(), _ctx.conditionStackChange()), ["stop"]))
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  class: "text-primary",
                  label: _ctx.t('data.filtering.applyFilter'),
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                  _ctx.conditionReady(_ctx.newCondition)
                    ? [_ctx.addCondition(_ctx.newCondition), _ctx.resetNewCondition(), _ctx.conditionStackChange()]
                    : ''
                ), ["stop"]))
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedConditionStack, (condition, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_q_btn_dropdown, {
            color: "grey-3",
            "text-color": "grey-7",
            "no-caps": "",
            onClick: _withModifiers(($event: any) => (_ctx.editCondition = condition), ["stop"]),
            ref_for: true,
            ref: "editFilterRef"
          }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.conditionLabel(condition.field)) + " ", 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(' ' + _ctx.operatorLabel(condition.operation)), 1),
                  (
                      'dateModifier' in condition &&
                      condition.dateModifier !== null &&
                      condition.dateModifier?.key === 'exactDate'
                    )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(
                      condition.dateModifier !== null ? 'text-weight-regular text-grey-7' : ''
                    )
                      }, _toDisplayString(' ' + _ctx.t(`data.filtering.operators.date.${condition.dateModifier?.key}`)), 3))
                    : _createCommentVNode("", true),
                  (
                      'dateModifier' in condition &&
                      condition.dateModifier !== null &&
                      condition.dateModifier?.key !== 'exactDate'
                    )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(' ' + _ctx.t(`data.filtering.operators.date.${condition.dateModifier?.key}`)), 1))
                    : (condition.field?.type === 'boolean')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(' ')))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(' ' + condition.value), 1))
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_filters_stackable_inputs, {
                "fields-as-array": _ctx.fieldsAsArray,
                fields: _ctx.fields,
                inputs: condition,
                onConditionalChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateEditCondition($event))),
                onEnterKey: ($event: any) => (
                _ctx.conditionReady(condition) && _ctx.updateReady(condition)
                  ? [
                      _ctx.updateCondition(index),
                      _ctx.resetEditCondition(),
                      _ctx.conditionStackChange(),
                      _ctx.closeDialog(_ctx.editFilterRef),
                    ]
                  : ''
              )
              }, null, 8, ["fields-as-array", "fields", "inputs", "onEnterKey"]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  class: "text-grey-7",
                  label: _ctx.t('form.cancel'),
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.resetEditCondition()), ["stop"]))
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  class: "text-negative",
                  label: _ctx.t('form.deleteFilter'),
                  onClick: _withModifiers(($event: any) => (_ctx.removeCondition(index), _ctx.conditionStackChange()), ["stop"])
                }, null, 8, ["label", "onClick"]), [
                  [_vShow, !_ctx.updateReady(condition)],
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  class: "text-primary",
                  label: _ctx.t('form.updateFilter'),
                  onClick: _withModifiers(($event: any) => (_ctx.updateCondition(index), _ctx.resetEditCondition(), _ctx.conditionStackChange()), ["stop"])
                }, null, 8, ["label", "onClick"]), [
                  [_vShow, _ctx.updateReady(condition)],
                  [_directive_close_popup]
                ])
              ])
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128))
    ])
  ]))
}